import {compact, isArray, isFunction, keys, memoize} from 'lodash';

export const migrateFieldOperatorsConfig = memoize(operators =>
    isArray(operators)
        ? operators
        : compact(
              keys(operators).map(operator => {
                  let operatorSetup = operators[operator];
                  if (operatorSetup) {
                      let result = {
                          id: operator,
                      };
                      if (isArray(operatorSetup)) result.values = operatorSetup;
                      else if (isFunction(operatorSetup)) {
                          result.fetchSuggestions = operatorSetup;
                      }
                      return result;
                  }
              })
          )
);
